import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import toast from 'react-hot-toast';
import axios from 'axios';
import PhoneInput from 'react-phone-number-input';
import { isValidPhoneNumber } from 'react-phone-number-input';
import instantSupportTick from '../../assets/images/instant-support-tickmark.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import Topbar from '../PulseSurvey/Topbar';
import {
  capitalizeFirstLetter,
  errorToast,
  getFileType,
  useOutsideClick
} from '../../utils/helper';
import { AddCustomPlansBenefitsValidation } from '../../validation/AddPlanBenifitsValidation';
import FaqListItem from '../../component/tutorials/FaqListItem';
import FaqForm from '../../component/tutorials/FaqForm';
import Icons from '../../component/svgs/icons';
import Loader from '../../component/common/Loader';
import { CompanyApi } from '../../api/companyApi';
import { Api } from '../../api';
import { shoorahBenefitsPageData as mainPageData } from '../../utils/pageContent';

const initialFaq = {
  faqQuestion: '',
  faqAnswer: ''
};

const AddCustomBenefitsPage = () => {
  const pageData = mainPageData.addCustomBenefitsPageData;
  const navigate = useNavigate();
  const instantSupportBrandImage = useRef(null);
  const dropdownRef = useRef(null);
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const formType = queryParams.get('type');
  const editId = queryParams.get('id');
  const [loading, setLoading] = useState(false);
  const [addUpdateNumberText, setAddUpdateNumberText] = useState('Add');
  const [selectedImage, setSelectedImage] = useState('');
  const [imagePreview, setImagePreview] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [allocatedNumber, setAllocatedNumber] = useState('');
  const [url, setUrl] = useState('');
  const [errors, setErrors] = useState({});
  const [faq, setFaq] = useState([]);
  const [isPreview, setIsPreview] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [companyDropdownOpen, setCompanyDropdownOpen] = useState(false);
  const [companySearchText, setCompanySearchText] = useState('');
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [companyListForDropdown, setcompanyListForDropdown] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const dropdownListRef = useRef(null);
  const [isSearching, setIsSearching] = useState(false);
  const [supportStatus, setSupportStatus] = useState(0);
  const [companyName, setCompanyName] = useState('');
  const [companyID, setCompanyID] = useState('');
  const [displayText, setDisplayText] = useState('');
  const [totalnumberofCompaniesInTheDropdown, settotalnumberofCompaniesInTheDropdown] = useState();
  const [applyShoorahPlan, setApplyShoorahPlan] = useState(false);
  const [plans, setPlans] = useState([]);
  const [customPlanData, setCustomPlanData] = useState(null);
  const [editMode, setEditMode] = useState(false);

  const fetchCustomPlans = async () => {
    setLoading(true);
    try {
      const response = await CompanyApi.viewCustomPlansBenefits();
      if (response?.data?.meta?.code === 1) {
        setCustomPlanData(response?.data?.data);
        setIsPreview(true);
        setEditMode(false);
      } else {
        setCustomPlanData(null);
      }
    } catch (error) {
      console.error('Failed to fetch custom plans:', error);
    } finally {
      setLoading(false);
    }
  };

  const viewCustomData = async (
    pageNumber,
    pageSize,
    searchKey = '',
    planType,
    status,
    createdAt,
    id
  ) => {
    setLoading(true);
    Api.getbenefitsList(pageNumber, pageSize, searchKey, planType, status, createdAt, id)
      .then((response) => {
        setLoading(false);
        if (response?.data) {
          if (response?.data?.data) {
            // console.log(response?.data?.data, 'response data data');
            setCustomPlanData(response?.data?.data);
            if (response?.data?.data?.companyID) {
            setCompanyID(response?.data?.data?.companyID);
          }
          if(response?.data?.data?.businessName){
            setCompanyName(response?.data?.data?.businessName);
            setCompanySearchText(response?.data?.data?.businessName);
          }
            setEditMode(false);
            setIsPreview(true);
            setCurrentPage(pageNumber);
            setLoading(false);
          } else {
            setLoading(false);
            errorToast(pageData.somethingWentWrongMessage);
          }
        } else if (response?.code === 401) {
          errorToast(response?.message);
          setLoading(false);
        } else if (response?.data?.meta?.code === 0) {
          setLoading(false);
          setCurrentPage(1);
          // setUsersList([]);
          errorToast(response?.data?.meta?.message);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log('error we got after the API call', error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

    useEffect(() => {
fetchCompanies(1, companySearchText, false);
  }, [])

  useEffect(() => {
    if (editId) {
      viewCustomData(1, 10, '', '', '', '', editId);
    }
  }, [editId]);

  const handleShoorahPlanToggle = () => {
    setApplyShoorahPlan((prev) => !prev);
  };

  useEffect(() => {
    if (!formType) {
      fetchCustomPlans();
    }
  }, [formType]);


  const handleEditMode = () => {
    setEditMode((prev) => !prev);
    setIsPreview((prev) => !prev);
  };

  useEffect(() => {
    if (customPlanData !== null) {
      const plans =
        customPlanData?.plans.length > 0 &&
        customPlanData?.plans.map((plan) => {
          return {
            faqQuestion: plan?.title,
            faqAnswer: plan?.description
          };
        });
      if (customPlanData?.businessLogo) {
        setImagePreview(customPlanData?.businessLogo);
      }

      setFaq(plans ? plans : []);
      if (customPlanData?.isShoorahPlanPurchased) {
        setApplyShoorahPlan(true);
        setPlans(pageData?.shoorahPlansData);
      } else {
        setApplyShoorahPlan(false);
        setPlans(customPlanData?.plans);
      }
      setAllocatedNumber(customPlanData?.phone);
      setName(customPlanData?.planTitle);
      setEmail(customPlanData?.email);
      setUrl(customPlanData?.url);
    }
  }, [customPlanData]);

  useEffect(() => {
    if (applyShoorahPlan) {
      setFaq([]);
      setPlans(pageData?.shoorahPlansData);
      setName('Shoorah');
      setEmail('info@shoorah.io');
      setUrl('https://www.shoorah.io');
    } else {
      const plans =
        customPlanData?.plans.length > 0 &&
        customPlanData?.plans.map((plan) => {
          return {
            faqQuestion: plan?.title,
            faqAnswer: plan?.description
          };
        });
      setFaq(plans ? plans : []);
      setPlans(customPlanData?.plans ? customPlanData?.plans : []);
      setName('');
      setEmail('');
      setUrl('');
    }
  }, [applyShoorahPlan]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === 'companySearch') {
      setCompanySearchText(value);
    }
  };

  useOutsideClick(dropdownRef, () => {
    setCompanyDropdownOpen(false);
    if (selectedCompany) {
      setCompanySearchText(displayText);
    }
  });

  const fetchCompanies = (page = 1, searchKey = '', isAppending = false) => {
    const isInitialLoad = page === 1 && searchKey === '' && !isAppending;
    if (isAppending) {
      setIsLoadingMore(true);
    }
    if (!isInitialLoad && !isAppending) {
      setIsSearching(true);
    }
    Api.getInstantSupportAllCompanies(page, 25, searchKey, '', -1)
      .then((response) => {
        if (isInitialLoad) {
          setIsLoading(false);
        }
        if (isAppending) {
          setIsLoadingMore(false);
        }
        if (!isInitialLoad && !isAppending) {
          setIsSearching(false);
        }
        if (response?.data?.data) {
          const newCompanies = response?.data?.data?.map((item) => ({
            ...item,
            name: item?.company_name,
            companyID: item?.adminId
          }));
          if (isAppending) {
            setcompanyListForDropdown((prev) => [...prev, ...newCompanies]);
          } else {
            setcompanyListForDropdown(newCompanies);
          }
          setCurrentPage(page);
          settotalnumberofCompaniesInTheDropdown(response?.data?.meta?.totalRecords);
          setHasMore(newCompanies.length === 25);
        } else if (response?.code === 401) {
          errorToast(response?.message);
          if (isInitialLoad) setIsLoading(false);
          if (isAppending) setIsLoadingMore(false);
          if (!isInitialLoad && !isAppending) setIsSearching(false);
        } else if (response?.data?.meta?.code === 0) {
          if (isInitialLoad) setIsLoading(false);
          if (isAppending) setIsLoadingMore(false);
          if (!isInitialLoad && !isAppending) setIsSearching(false);
          settotalnumberofCompaniesInTheDropdown(0);
          setcompanyListForDropdown([]);
          errorToast(response?.data?.meta?.message);
        } else {
          if (isInitialLoad) setIsLoading(false);
          if (isAppending) setIsLoadingMore(false);
          if (!isInitialLoad && !isAppending) setIsSearching(false);
        }
      })
      .catch((error) => {
        console.log(error, 'error while calling the getAllCompanies API');
        if (isInitialLoad) setIsLoading(false);
        if (isAppending) setIsLoadingMore(false);
        if (!isInitialLoad && !isAppending) setIsSearching(false);
      });
  };

  useEffect(() => {
    if (!companyDropdownOpen) return;
    const delayDebounceFn = setTimeout(() => {
      setCurrentPage(1);
      fetchCompanies(1, companySearchText, false);
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [companySearchText, companyDropdownOpen]);

  const handleSearchFocus = () => {
    if (selectedCompany) {
      setCompanySearchText('');
    }
    setCompanyDropdownOpen(true);
    if (companyListForDropdown.length === 0) {
      fetchCompanies(1, '', false);
    }
  };

  const handleDropdownScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    if (scrollHeight - scrollTop <= clientHeight + 50) {
      if (!isLoadingMore && hasMore) {
        const nextPage = currentPage + 1;
        setCurrentPage(nextPage);
        fetchCompanies(nextPage, companySearchText, true);
      }
    }
  };

  const handleCompanySelect = (company) => {
    setSelectedCompany(company);
    setCompanyName(company.company_name);
    setCompanyID(company._id);
    setDisplayText(company.company_name);
    setCompanySearchText(company.company_name);
    setCompanyDropdownOpen(false);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handlePhoneNumberChange = (value) => {
    if (!value) {
      setAllocatedNumber('');
      setErrors((prev) => ({
        ...prev,
        phoneNumber: pageData.phoneNumberRequriedMessage
      }));
      return;
    }

    setAllocatedNumber(value);

    try {
      if (isValidPhoneNumber(value)) {
        setErrors((prev) => ({ ...prev, phoneNumber: '' }));
      } else {
        setErrors((prev) => ({
          ...prev,
          phoneNumber: pageData.enterValidNumberMessage
        }));
      }
    } catch (error) {
      setErrors((prev) => ({
        ...prev,
        phoneNumber: pageData.inValidNumberFormatMessage
      }));
    }
  };

  const handleURLChange = (e) => {
    const input = e.target.value;
    setUrl(input);

    const urlPattern = new RegExp(
      '^(https?:\\/\\/)?' +
        '((([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,})|' +
        'localhost|' +
        '\\d{1,3}(\\.\\d{1,3}){3})' +
        '(\\:\\d+)?(\\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?$',
      'i'
    );

    if (!input.trim()) {
      setErrors((prev) => ({
        ...prev,
        url: pageData.urlIsRequriedMessage
      }));
    } else if (!urlPattern.test(input)) {
      setErrors((prev) => ({
        ...prev,
        url: pageData.enterValidUrlMessage
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        url: ''
      }));
    }
  };

  const handleAddFaq = () => {
    if (faq.length === 0) {
      setFaq([{ ...initialFaq }]);
      setEditingIndex(0);
      return;
    }

    if (editingIndex !== null) {
      const editingFaq = faq[editingIndex];
      let hasError = false;
      const errorsCopy = { ...errors };

      if (!editingFaq?.faqQuestion?.trim()) {
        errorsCopy[`faqQuestion${editingIndex}`] = pageData.pleaseEnterPlanTitleMessage;
        hasError = true;
      }
      if (!editingFaq?.faqAnswer?.trim()) {
        errorsCopy[`faqAnswer${editingIndex}`] = pageData.pleaseEnterPlanDescriptionMessage;
        hasError = true;
      }

      if (hasError) {
        setErrors(errorsCopy);
        return;
      }

      delete errorsCopy[`faqQuestion${editingIndex}`];
      delete errorsCopy[`faqAnswer${editingIndex}`];
      setErrors(errorsCopy);
    }

    const newIndex = faq.length;
    setFaq((prev) => [...prev, { ...initialFaq }]);
    setEditingIndex(newIndex);
  };

  const handleChangeFqa = (index, name, value) => {
    if (isPreview) return;

    const trimmedLength = value?.trim()?.replace(/\s+/g, ' ')?.length;

    if (name === 'faqQuestion') {
      if (trimmedLength > 120) {
        setErrors((prev) => ({
          ...prev,
          [`faqQuestion${index}`]: pageData.planTitleMaxcharacterErrorMessage
        }));
      } else {
        setErrors((prev) => ({ ...prev, [`faqQuestion${index}`]: '' }));
      }
    }

    if (name === 'faqAnswer') {
      if (trimmedLength > 1200) {
        setErrors((prev) => ({
          ...prev,
          [`faqAnswer${index}`]: pageData.planDescriptionMaxcharacterErrorMessage
        }));
      } else {
        setErrors((prev) => ({ ...prev, [`faqAnswer${index}`]: '' }));
      }
    }

    setFaq((prevFaqs) => prevFaqs.map((faq, i) => (i === index ? { ...faq, [name]: value } : faq)));
  };

  const handleRemoveFaq = (index) => {
    const updatedFaq = faq.filter((_, i) => i !== index);
    const updatedErrors = { ...errors };

    delete updatedErrors[`faqQuestion${index}`];
    delete updatedErrors[`faqAnswer${index}`];

    const newErrors = {};
    updatedFaq.forEach((_, i) => {
      if (errors[`faqQuestion${i >= index ? i + 1 : i}`]) {
        newErrors[`faqQuestion${i}`] = errors[`faqQuestion${i >= index ? i + 1 : i}`];
      }
      if (errors[`faqAnswer${i >= index ? i + 1 : i}`]) {
        newErrors[`faqAnswer${i}`] = errors[`faqAnswer${i >= index ? i + 1 : i}`];
      }
    });

    setFaq(updatedFaq);
    setErrors(newErrors);

    if (editingIndex === index) {
      setEditingIndex(null);
    } else if (editingIndex > index) {
      setEditingIndex(editingIndex - 1);
    }
  };

  const handleEditFaq = (index) => {
    setEditingIndex(index);
  };

  const handleAddCustomPlans = async () => {
    const customPlansObj = {
      name: name,
      email: email,
      phoneNumber: allocatedNumber,
      url: url
    };

    const { errors: validationErrors, isValid } = AddCustomPlansBenefitsValidation(customPlansObj);

    if (!isValid) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});

    if (formType) {
      if (!companyID.trim()) {
        errorToast(pageData.pleaseSelectACompanyErrorMessage);
        return;
      }
      setLoading(true);
      const payload = {
        id: customPlanData?._id ? customPlanData?._id : null,
        planTitle: name,
        companyID: companyID,
        businessName : companyName,
        email: email,
        phone: allocatedNumber,
        url: url,
        businessLogo: selectedImage ? getFileType(selectedImage) : null,
        isShoorahPlanPurchased: applyShoorahPlan,
        plans:
          faq.length > 0
            ? faq.map((plan) => ({
                title: plan.faqQuestion,
                description: plan.faqAnswer
              }))
            : []
      };
      // console.log(payload, ' form type company ');
      try {
        const response = await Api.addCustomPlansBenefits(payload);

        if (response?.data?.meta?.code === 1) {
          toast.success(response?.data?.meta?.message || pageData.customPlanAddedSuccessMessage);
          if (response?.data?.meta?.businessLogoUrl?.uploadURL) {
            setLoading(true);
            await axios.put(response?.data?.meta?.businessLogoUrl?.uploadURL, selectedImage, {
              headers: {
                'content-type': `${selectedImage?.type?.split('/')[0]}/${
                  selectedImage?.name?.split('.')[1]
                }`
              }
            });
          }
          navigate('/benefits');
        } else {
          toast.error(response?.data?.meta?.message || pageData.somethingWentWrongMessage);
        }
      } catch (error) {
        toast.error(pageData.failedToAddCustomPlanMessage);
        console.error(error);
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(true);
      const payload = {
        id: customPlanData?._id ? customPlanData?._id : null,
        planTitle: name,
        email: email,
        phone: allocatedNumber,
        url: url,
        businessLogo: selectedImage ? getFileType(selectedImage) : null,
        plans:
          faq.length > 0
            ? faq.map((plan) => ({
                title: plan.faqQuestion,
                description: plan.faqAnswer
              }))
            : [],
        isShoorahPlanPurchased: applyShoorahPlan
      };
      // console.log(payload, 'payload when b2b login');
      try {
        const response = await CompanyApi.addCustomPlansBenefits(payload);

        if (response?.data?.meta?.code === 1) {
          toast.success(response?.data?.meta?.message || pageData.customPlanAddedSuccessMessage);
          if (response?.data?.meta?.businessLogoUrl?.uploadURL) {
            setLoading(true);
            await axios.put(response?.data?.meta?.businessLogoUrl?.uploadURL, selectedImage, {
              headers: {
                'content-type': `${selectedImage?.type?.split('/')[0]}/${
                  selectedImage?.name?.split('.')[1]
                }`
              }
            });
          }
          // navigate(getPathForInstantSupport('/benefits/add-custom-benefits'));
          window.location.reload();
        } else {
          toast.error(response?.data?.meta?.message || pageData.somethingWentWrongMessage);
        }
      } catch (error) {
        toast.error(pageData.failedToAddCustomPlanMessage);
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="relative ">
      {loading && <Loader />}
      <Helmet>
        <meta charSet="utf-8" />
        <title>{pageData.metaTitle}</title>
      </Helmet>
      <Topbar
        title={pageData.pageTitle}
        hasDesc={true}
        description={pageData.pageDescription}
        infoBtn={false}
      />
      <div className="flex flex-col w-full max-w-4xl mt-12 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl my-5 lg:p-6 p-4 shadow-md">
        <div className="flex flex-column justify-between items-center">
          {!isPreview ? (
            <h1 className="text-xl mt-2 font-medium leading-9">
              {editMode ? pageData.editText : addUpdateNumberText} {pageData.customBenefitsText}
            </h1>
          ) : (
            <h1 className="text-xl mt-2 font-medium leading-9">
              {pageData.viewText} {pageData.customBenefitsText}
            </h1>
          )}
          {customPlanData && !applyShoorahPlan && (
            <button
              className="btn-primary w-max mt-2"
              onClick={handleEditMode}
            >
              {isPreview ? pageData.editText : pageData.viewText}
            </button>
          )}
        </div>
        <div>
          <input
            type="file"
            accept=".jpg, .jpeg, .png"
            className="hidden"
            ref={instantSupportBrandImage}
            onChange={handleImageChange}
            disabled={isPreview}
          />

          <div
            onClick={() => instantSupportBrandImage.current.click()}
            className="flex justify-center mt-8 items-center overflow-hidden rounded-[9px] border-[1.5px] border-[#D4D4D4] border-dashed dark:border-shoorah-darkBorder w-40 h-40 bg-[#F1F1F1] dark:bg-shoorah-darkBgColor relative cursor-pointer"
          >
            {imagePreview ? (
              <img
                src={imagePreview}
                alt="Selected"
                className="absolute w-full h-full object-cover rounded-[9px]"
              />
            ) : (
              <div className="flex flex-col justify-center items-center">
                <svg
                  className="mb-2 text-shoorah-primary"
                  width="22"
                  height="22"
                  viewBox="0 0 23 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.89999 20.0445H14.3667C18.9222 20.0445 20.7444 18.2223 20.7444 13.6667V8.20004C20.7444 3.64449 18.9222 1.82227 14.3667 1.82227H8.89999C4.34444 1.82227 2.52222 3.64449 2.52222 8.20004V13.6667C2.52222 18.2223 4.34444 20.0445 8.89999 20.0445Z"
                    fill="#D4D4D4"
                    stroke="#0B0B0B"
                    strokeWidth="1.36667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8.90004 9.11124C9.90643 9.11124 10.7223 8.2954 10.7223 7.28902C10.7223 6.28263 9.90643 5.4668 8.90004 5.4668C7.89366 5.4668 7.07782 6.28263 7.07782 7.28902C7.07782 8.2954 7.89366 9.11124 8.90004 9.11124Z"
                    fill="#D4D4D4"
                    stroke="#0B0B0B"
                    strokeWidth="1.36667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M3.13263 17.2652L7.62441 14.2494C8.34418 13.7665 9.38285 13.8212 10.0297 14.3769L10.3304 14.6412C11.0411 15.2516 12.1891 15.2516 12.8997 14.6412L16.69 11.3885C17.4006 10.7781 18.5486 10.7781 19.2593 11.3885L20.7444 12.6641"
                    fill="#D4D4D4"
                  />
                  <path
                    d="M3.13263 17.2652L7.62441 14.2494C8.34418 13.7665 9.38285 13.8212 10.0297 14.3769L10.3304 14.6412C11.0411 15.2516 12.1891 15.2516 12.8997 14.6412L16.69 11.3885C17.4006 10.7781 18.5486 10.7781 19.2593 11.3885L20.7444 12.6641"
                    stroke="#0B0B0B"
                    strokeWidth="1.36667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <h5 className="text-[8px]">
                  {pageData.dropTheBrandtext} <br /> {pageData.imageText}{' '}
                  <span className="text-shoorah-primary font-medium">{pageData.hereText}</span>
                </h5>
              </div>
            )}
          </div>
          {selectedImage && (
            <p className="mt-2 text-xs text-gray-600">
              {pageData.selectedText} {selectedImage.name} ({Math.round(selectedImage.size / 1024)}{' '}
              {pageData.imageFileType})
            </p>
          )}
        </div>
        {/* Image Upload End */}

        {/* Toggle button */}
        {!isPreview && !editMode && (
          <div className="flex items-center gap-5 mt-10">
            <label className="flex items-center gap-2 text-sm font-medium text-gray-700 dark:text-gray-300">
              <span>{pageData.applyShoorahBenefitsPlanTtext}</span>
              <div
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 cursor-pointer ${
                  applyShoorahPlan ? 'bg-shoorah-primary' : 'bg-gray-200'
                }`}
                onClick={handleShoorahPlanToggle}
                role="switch"
                aria-checked={applyShoorahPlan}
              >
                <span
                  className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                    applyShoorahPlan ? 'translate-x-6' : 'translate-x-1'
                  }`}
                />
              </div>
            </label>
          </div>
        )}

        {/* Toggle Button for Aplly plans */}

        <h1 className="text-base mt-5 font-medium leading-9">
          {pageData.nameLabel} <span className="text-red-500">*</span>
        </h1>
        <div className="sm:grid sm:grid-cols-12 gap-2 mt-2 sm:w-[100%] w-full h-10">
          <div className="col-span-1 sm:col-span-7">
            <input
              className="w-full sm:mb-0 rounded-lg px-5 py-2 bg-shoorah-normanGray border-[1.5px] border-shoorah-borderGray dark:text-shoorah-darkBg dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder focus:outline-none"
              type="text"
              name="benefitsName"
              placeholder={pageData.nameplaceholder}
              value={name}
              disabled={applyShoorahPlan || isPreview ? true : false}
              onChange={(e) => {
                const value = capitalizeFirstLetter(e.target.value);
                setName(value);
                if (value) {
                  setErrors((prev) => ({ ...prev, name: '' }));
                } else {
                  setErrors((prev) => ({ ...prev, name: pageData.nameRequriedtext }));
                }
              }}
            />
            {errors.name && <p className="text-red-500 text-sm mt-2">{errors.name}</p>}
          </div>
        </div>
        {/* Name End */}

        {formType === 'addcompany' && (
          <>
            <h1 className="text-base mt-10 font-medium leading-9">
              {pageData.companyNameLabel} <span className="text-red-500">*</span>
            </h1>
            <div className="sm:grid sm:grid-cols-12 gap-2 mt-2 sm:w-[100%] w-full h-10">
              <div className="col-span-1 sm:col-span-7" ref={dropdownRef}>
                <div className="relative">
                  <div
                    className="w-full bg-shoorah-normanGray dark:bg-shoorah-darkBgColor rounded-lg pl-[15px] border-2 border-shoorah-borderGray dark:border-gray-600 py-2 focus:outline-none cursor-pointer flex justify-between items-center"
                    disabled={isPreview ? true : false}
                    onClick={() => {
          if (!isPreview) setCompanyDropdownOpen(!companyDropdownOpen);
        }}
                  >
                    <input
                      className="w-full bg-transparent border-none focus:outline-none cursor-text text-black dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                      placeholder={pageData.companyNamePlaceholder}
                      name="companySearch"
                      value={companySearchText}
                      onChange={handleInputChange}
                      onFocus={handleSearchFocus}
                      onClick={(e) => {
                        e.stopPropagation();
                        setCompanyDropdownOpen(true);
                      }}
                      disabled={isPreview ? true : false}
                    />
                    <div className="pr-3">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="text-black dark:text-white"
                      >
                        <path
                          d="M4 6L8 10L12 6"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>

                  {companyDropdownOpen && (
                    <div
                      className="absolute z-10 w-full mt-1 bg-white border-2 border-shoorah-borderGray rounded-lg shadow-lg max-h-60 overflow-y-auto"
                      ref={dropdownListRef}
                      onScroll={handleDropdownScroll}
                    >
                      {isSearching ? (
                        <div className="px-4 py-2 text-center text-gray-500">
                          <div className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"></div>
                          <span className="ml-2">{pageData.searchLabel}</span>
                        </div>
                      ) : companyListForDropdown.length > 0 ? (
                        <>
                          {companyListForDropdown.map((company, index) => (
                            <div
                              key={index}
                              className={`px-4 py-2 hover:bg-shoorah-normanGray cursor-pointer ${
                                selectedCompany && selectedCompany.adminId === company.adminId
                                  ? 'bg-shoorah-normanGray font-semibold'
                                  : ''
                              }`}
                              onClick={() => handleCompanySelect(company)}
                            >
                              {company.company_name
                                ? company.company_name
                                    .split(' ')
                                    .map(
                                      (word) =>
                                        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                                    )
                                    .join(' ')
                                : ''}
                            </div>
                          ))}
                          {isLoadingMore && (
                            <div className="px-4 py-2 text-center text-gray-500">
                              <div className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"></div>
                              <span className="ml-2">{pageData.loadingMoreText}</span>
                            </div>
                          )}
                        </>
                      ) : (
                        <div className="px-4 py-2 text-gray-500">
                          {isLoading ? pageData.loadingText : pageData.noCompanyFoundText}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}

        {/* Company name End */}

        <h1 className="text-base mt-10 font-medium leading-9">
          {pageData.emailText} <span className="text-red-500">*</span>
        </h1>
        <div className="sm:grid sm:grid-cols-12 gap-2 mt-2 sm:w-[100%] w-full h-10">
          <div className="col-span-1 sm:col-span-7">
            <input
              className="w-full sm:mb-0 rounded-lg px-5 py-2 bg-shoorah-normanGray border-[1.5px] border-shoorah-borderGray dark:text-gray-300 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder focus:outline-none"
              type="text"
              name="email"
              placeholder={pageData.emailPlaceholder}
              value={email}
              disabled={applyShoorahPlan || isPreview ? true : false}
              onChange={(e) => {
                const value = e.target.value;
                setEmail(value);
                const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                const emails = value.split(',').map((email) => email.trim());
                const invalidEmails = emails.filter((email) => email && !regex.test(email));
                if (!value.trim()) {
                  setErrors((prev) => ({ ...prev, email: pageData.emailIsRequriedMessage }));
                } else if (invalidEmails.length > 0) {
                  setErrors((prev) => ({
                    ...prev,
                    email: pageData.invalidEmailAddressMessage
                  }));
                } else {
                  setErrors((prev) => ({ ...prev, email: '' }));
                }
              }}
            />
            {errors.email && <p className="text-red-500 text-sm mt-2">{errors.email}</p>}
          </div>
        </div>

        {/* Email End */}

        <h1 className="text-base mt-10 font-medium leading-9">{pageData.phoneNumberLabel}</h1>
        <div className="sm:grid sm:grid-cols-12 gap-2 mt-2 sm:w-[100%] w-full h-10">
          <div className="col-span-1 sm:col-span-7">
            <PhoneInput
              className=" text-[#666666] bg-shoorah-normanGray border-[1.5px] border-shoorah-borderGray
               dark:text-shoorah-darkBg dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder focus:outline-none rounded-md h-10 px-2"
              placeholder={pageData.phoneNumberPlaceholder}
              name="phoneNumberr"
              value={allocatedNumber}
              disabled={applyShoorahPlan || isPreview ? true : false}
              onChange={handlePhoneNumberChange}
            />
            {errors.phoneNumber && !isValidPhoneNumber(allocatedNumber) && (
              <p className="text-red-500 text-sm mt-2">
                {errors.phoneNumber ? errors.phoneNumber : pageData.enterValidPhoneNumberMessage}
              </p>
            )}
          </div>
        </div>

        {/* Phone Number End */}

        <h1 className="text-base mt-10 font-medium leading-9">{pageData.urlText}</h1>
        <div className="sm:grid sm:grid-cols-12 gap-2 mt-2 sm:w-[100%] w-full h-10">
          <div className="col-span-1 sm:col-span-7">
            <input
              className={`w-full sm:mb-0 rounded-lg px-5 py-2 bg-shoorah-normanGray border-[1.5px]  border-shoorah-borderGray
               dark:text-shoorah-darkBg dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder focus:outline-none`}
              type="text"
              placeholder={pageData.urlPlaceholder}
              disabled={applyShoorahPlan || isPreview ? true : false}
              value={url}
              onChange={handleURLChange}
            />
            {errors.url && <p className="text-red-500 text-xs mt-1">{errors.url}</p>}
          </div>
        </div>

        {/* URL end */}
        <div className="space-y-4 mb-5 mt-10">
          <h3 className="font-medium text-shoorah-lightBlack dark:text-white">
            {applyShoorahPlan ? 'Shoorah Plan Details' : pageData.addDetilsLabel}
          </h3>
          {!isPreview &&
            faq?.map((item, index) => {
              const isEditing = editingIndex === index;

              if (isEditing) {
                return (
                  <div key={index} className="relative">
                    <FaqForm
                      index={index}
                      data={item}
                      error1={errors?.[`faqQuestion${index}`]}
                      error2={errors?.[`faqAnswer${index}`]}
                      onChange={handleChangeFqa.bind(null, index)}
                      onRemove={handleRemoveFaq.bind(null, index)}
                      disabled={isPreview || applyShoorahPlan}
                      title={'Plan details'}
                      questionPlaceholder={'Enter title'}
                      answerPlaceholder={'Enter description'}
                    />
                  </div>
                );
              } else {
                return (
                  <FaqListItem
                    key={index}
                    data={item}
                    index={index}
                    onRemove={handleRemoveFaq.bind(null, index)}
                    onEdit={handleEditFaq.bind(null, index)}
                    disabled={isPreview || applyShoorahPlan}
                    title={'Plan details'}
                  />
                );
              }
            })}

          {(isPreview || applyShoorahPlan) &&
            plans?.map((data, index) => (
              <div
                key={index}
                className="w-full mx-auto mt-6 bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-2xl overflow-hidden"
              >
                <div className="divide-y divide-gray-200 dark:divide-shoorah-darkBorder">
                  <div className="hover:bg-gray-50 dark:hover:bg-gray-800 px-4 sm:px-6 py-3 sm:py-4">
                    <label className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3">
                      <div className="flex items-center w-full sm:w-auto">
                        <span className="font-medium text-gray-900 dark:text-white ml-2 sm:ml-3">
                          {data?.title}
                        </span>
                      </div>
                    </label>
                  </div>

                  <div className="px-8 py-4">
                    <p className="text-gray-700 dark:text-gray-300">{data?.description}</p>

                    {data?.planRequirements?.length > 0 && (
                      <div className="mt-4">
                        <h4 className="text-gray-900 dark:text-gray-300 font-medium mb-2">
                          {pageData.informationTitle}
                        </h4>
                        {data.planRequirements.map((text, idx) => (
                          <div key={idx} className="flex items-start my-3 text-xs sm:text-sm">
                            <img
                              src={instantSupportTick}
                              alt="Tick"
                              className="w-[20px] sm:w-[24px] h-[20px] sm:h-[24px] dark:invert mr-2"
                            />
                            <span className="text-[#606060] dark:text-gray-300">{text}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}

          {!isPreview && applyShoorahPlan === false && (
            <button
              onClick={handleAddFaq}
              className="flex items-center gap-2 mt-4 border-[1.5px] disabled:opacity-70 border-[#A1A1A1] rounded-full text-sm font-medium text-shoorah-lightBlack dark:text-white py-[5px] px-10 w-max mb-3 hover:bg-gray-50 dark:hover:bg-shoorah-darkBgColor transition-colors"
            >
              <Icons.plusCircle className="w-4 h-4" />
              {pageData.addDetilsLabel}
            </button>
          )}
          {errors?.faq && <p className="text-red-500 text-sm mt-2">{errors?.faq}</p>}
        </div>

        {!isPreview && (
          <button
            className="btn-primary w-max mt-2"
            onClick={handleAddCustomPlans}
          >
            {applyShoorahPlan
              ? pageData.addShoorahPlanBtnText
              : editMode
              ? pageData.editCustomPlanBtnText
              : pageData.addCustomPlansBtnText}
          </button>
        )}
      </div>
    </div>
  );
};

export default AddCustomBenefitsPage;
